export class CommonFunctions {
    dateToString(date: Date): string {
        if (date && date != null) {
            let dayTmp: string = date.getDate().toString();
            if (dayTmp.length == 1) {
                dayTmp = "0" + dayTmp;
            }
            let monthTmp: string = (date.getMonth() + 1).toString();
            if (monthTmp.length == 1) {
                monthTmp = "0" + monthTmp;
            }
            return (dayTmp + "/" + monthTmp + "/" + date.getFullYear());
        }
        return null;
    }

    stringToDate(string): Date {
        if (string && string != null && string.split("/").length == 3) {
            let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

            let dayTmp = string.split("/")[0];
            let monthTmp = months[parseInt(string.split("/")[1]) - 1];
            let yearTmp = string.split("/")[2];

            return new Date(dayTmp + " " + monthTmp + " " + yearTmp);
        }
        return null;
    }
} 